@if (ratingToast$ | async; as rating) {
  <div class="rating-toast" [class.big]="textMode" [@rating]>
    <button
      appButton
      name="DONTREPORT"
      location="rating"
      [iconButton]="true"
      color="simple"
      height="1"
      shape="round"
      class="close-button"
      (click)="close(rating.ratingName)"
    >
      <app-svg src="/assets/icons/cross.svg"></app-svg>
    </button>
    @if (!rated()) {
      <h2>{{ rating.title }}</h2>
      <p>{{ rating.description }}</p>
      <div class="stars" (mouseleave)="!animate() && starRating.set(0)">
        @for (star of stars; let i = $index; track i) {
          <button
            appButton
            name="star"
            location="rating"
            [analyticsExtra]="{ rating: star }"
            [iconButton]="true"
            [appTooltip]="animate() ? undefined : (star | ratings)"
            [skipDelay]="true"
            shape="round"
            color="vote-star"
            [class.active]="starRating() >= star"
            (mouseover)="!animate() && starRating.set(star)"
            (click)="!animate() && rate(rating.ratingName, star)"
          >
            <app-svg
              src="/assets/icons/star-filled.svg"
              [class.animated]="starRating() === star && animate()"
              size="1-5"
            ></app-svg>
            @if (starRating() === star && animate()) {
              <div class="star-sparks">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            }
          </button>
        }
      </div>
    } @else {
      <div class="post-stars">
        @for (star of stars; let i = $index; track i) {
          <div [class.empty]="starRating() < star"></div>
        }
      </div>
      @if (!textMode()) {
        <h2>Thank You!</h2>
        <p>We appreciate your vote. This will help us improve free tools further.</p>
      } @else {
        <h2>{{ rating.title }}</h2>
        <p>Thanks for your rating. Please let us know how we can improve this free tool.</p>
        <form [formGroup]="form" (ngSubmit)="submitText(rating.ratingName)">
          <app-input-field [control]="form.controls.message">
            <textarea formControlName="message" name="message"></textarea>
            <label>Your feedback...</label>
          </app-input-field>
          <button
            appButton
            name="submit"
            location="rating"
            color="primary"
            shape="round"
            height="4"
            spacing="full"
            class="cta"
            size="3"
          >
            Share Feedback
          </button>
        </form>
      }
    }
  </div>
}
